import React from 'react';

const wrapText = (tag, txt, opts = {}) => {
  const OutputTag = tag;
  return <OutputTag {...opts}>{txt}</OutputTag>;
};
export default wrapText;